<div class="app-root app-root--login">
  <div class="login-container">
    <router-outlet></router-outlet>
    <div class="wave wave1"></div>
    <div class="wave wave2"></div>
    <div class="wave wave3"></div>
    <div class="wave wave4"></div>
  </div>
</div>
